import Loading from "../components/Loading";

export default function () {
  return <Loading />;
}
